'use strict';

import React from 'react';
import classnames from 'classnames';

const Notification = (props) => {
  const { className, children } = props;
  return (
    <div
      className={classnames(
        className ? `ot-notification ${className}` : `ot-notification`
      )}
    >
      {children}
    </div>
  );
};

export default Notification;
